export const calculateScrollPercentage = (scrollLeft: number, maxScrollLeft: number): number => (
    maxScrollLeft > 0 ? Math.max(0, Math.min(100, (scrollLeft / maxScrollLeft) * 100)) : 0
);
